<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Remove Products</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="cancel()"
  >
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <div class="card">
    <div class="card-header bg-light">
      <div class="row align-items-center">
        <div class="col">
          <p class="m-0">Select products to remove from the range</p>
        </div>
        <div class="col-4">
          <input
            type="text"
            class="form-control"
            placeholder="Filter by description / barcode..."
            [(ngModel)]="filterText"
            (ngModelChange)="onFilterChange()"
          />
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive" style="max-height: 50vh">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  class="form-check-input"
                  [checked]="areAllSelected()"
                  (change)="onToggleAll($event)"
                />
              </th>
              <th>Description</th>
              <th>Barcode</th>
              <th>UOS</th>
              <th>Unit</th>
              <th>Brand</th>
            </tr>
          </thead>
          <tbody>
            @if (filteredProducts.length === 0) {
            <tr>
              <td colspan="6" class="text-center text-muted py-4">
                No products available to remove.
              </td>
            </tr>
            } @else { @for (product of filteredProducts; track product) {
            <tr>
              <td>
                <input
                  type="checkbox"
                  class="form-check-input"
                  [checked]="selectedProducts.has(product.productId)"
                  (change)="toggleProduct(product.productId)"
                />
              </td>
              <td>{{ product.description }}</td>
              <td>{{ product.barcode }}</td>
              <td>{{ product.uos }}</td>
              <td>{{ product.unit }}</td>
              <td>{{ product.brand }}</td>
            </tr>
            } }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-danger"
    [disabled]="selectedProducts.size === 0"
    (click)="removeSelectedProducts()"
  >
    Remove Selected Products
  </button>
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
